import { useSyncExternalStore } from "react";
import { api } from "./api";

let state = { on: localStorage.getItem("bos_review_mode") === "1", keys: new Set(), loaded: false };
const subs = new Set();
const emit = () => subs.forEach((f) => f());
const subscribe = (f) => { subs.add(f); return () => subs.delete(f); };

async function load() {
  state = { ...state, loaded: true };
  try {
    const { data } = await api.get("/review/stars");
    state = { ...state, keys: new Set(data.keys) };
  } catch { state = { ...state, loaded: false }; }
  emit();
}

export function setReviewMode(on) {
  localStorage.setItem("bos_review_mode", on ? "1" : "0");
  state = { ...state, on };
  emit();
}

export async function toggleStar(key) {
  const keys = new Set(state.keys);
  keys.has(key) ? keys.delete(key) : keys.add(key);
  state = { ...state, keys };
  emit();
  await api.post("/review/stars/toggle", { key });
}

export function useReview() {
  const s = useSyncExternalStore(subscribe, () => state);
  if (s.on && !s.loaded) load();
  return s;
}
